import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import dateTable from '@/components/builders/configs/tables/statisticsDateTable';
import filters from '@/components/builders/configs/filters/statisticsDateFilter';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const statisticsRepository = RepositoryFactory.get('coupons');
const state = {
  repository: statisticsRepository,
  error: null,
};
const statisticsModule = {
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: statisticsRepository.statistics,
      headers: dateTable.headers.filter((header) => header.isShown),
      allHeaders: dateTable.headers,
      requestParams: {
        groupBy(state, getters, rootState, rootGetters) {
          return rootGetters['statistics/groupBy'];
        },
        startDate(state, getters, rootState, rootGetters) {
          return rootGetters['statistics/startDate'];
        },
        endDate(state, getters, rootState, rootGetters) {
          return rootGetters['statistics/endDate'];
        },
      },
      options: {
        sortBy: ['date'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
  },
  getters,
  mutations,
  actions,
};

export default stateExtender(statisticsModule);
